import { apiFetch } from '../utils/api';

export type SyncJobKey =
  | 'productCategories'
  | 'productBrands'
  | 'productAttributes'
  | 'productTemplates'
  | 'productMasters'
  | 'productVariants'
  | 'inventories'
  | 'employees'
  | 'promotions'
  | 'dreamPrices'
  | 'complimentaryReasons'
  | 'customers';

export interface SyncJobResponse {
  job: SyncJobKey;
  endpoint: string;
  syncedCount: number;
  responseStatusCode: number;
}

export const runSyncJob = (job: SyncJobKey) =>
  apiFetch<SyncJobResponse>('/sync-data/run-job', {
    method: 'POST',
    body: JSON.stringify({ job }),
  });
